<template>
  <!-- 拣货单详情-->
  <div class="PickingInfo" v-loading="loading">
    <div class="PickingInfo__top">
      <el-descriptions :column="3">
        <el-descriptions-item label="系统单号">
          {{ pickingInfo.rsys }}
        </el-descriptions-item>
        <el-descriptions-item label="检索单号">
          {{ pickingInfo.sretrieval }}
        </el-descriptions-item>
        <el-descriptions-item label="订单号">
          {{ pickingInfo.rorder }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-descriptions :column="2">
        <el-descriptions-item label="出货门店">
          {{ pickingInfo.sstore }}
        </el-descriptions-item>
        <el-descriptions-item label="门店地址">
          {{ pickingInfo.sstoreAddr }}
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-descriptions :column="2">
        <el-descriptions-item label="顾客地址">
          {{ pickingInfo.ccustomerAddr }}
        </el-descriptions-item>
        <el-descriptions-item label="订单渠道">
            <el-select v-model="pickingInfo.rchannel" filterable placeholder="请选择" :disabled="true" size="mini">
              <el-option v-for="item in channelOptions" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <div class="flex">
        <el-descriptions :column="2">
          <el-descriptions-item label="单据状态">
            {{ pickingInfo.zstate === 3 ? "已出库" : "已核销" }}
          </el-descriptions-item>
          <el-descriptions-item label="单据备注">
            {{ pickingInfo.cremark }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="w200 flex" style="justify-content: flex-end">
          <el-button type="primary" size="mini" plain @click="deviceDialogVisible = true">门店智控</el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <el-descriptions :column="4">
        <el-descriptions-item label="制单人">
          {{ pickingInfo.screate }}
        </el-descriptions-item>
        <el-descriptions-item label="制单时间">
          {{ pickingInfo.tcreate | time }}
        </el-descriptions-item>
        <el-descriptions-item label="审核人">
          {{ pickingInfo.saudit }}
        </el-descriptions-item>
        <el-descriptions-item label="审核时间">
          {{ pickingInfo.taudit | time }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="h450">
      <el-table ref="multipleTable" :data="tableData"  @selection-change="handleSelectionChange" height="450" :row-class-name="formatRow">
        <el-table-column type="selection" align="center" width="50" :selectable="checkSelectable"/>
        <el-table-column label="序号" align="center" width="50" type="index" />
        <el-table-column label="SKU" align="center" width="70" prop="csku" />
        <el-table-column label="图片" align="center" width="70">
          <template #default="scope">
            <el-image v-if="scope.row.cmasterUrl != null" :preview-src-list="[scope.row.cmasterUrl]" class="w50 h50" :src="scope.row.cmasterUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="货品编码" align="center" width="130" prop="cbarcode" />
        <el-table-column label="货品名称" align="center" prop="sgoods" />
        <el-table-column label="单位" align="center" width="70" prop="sunit" />
        <el-table-column label="单价" align="center" width="100" prop="nprice">
          <template slot-scope="scope">
            <div v-if="scope.row.nprice">￥ {{ scope.row.nprice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="库位" align="center" width="70" prop="zinventory" >
          <template #default="scope">
            <div class="hHP wHP flex marginLeft10" style="white-space: break-spaces;">
              <el-link type="primary" @click="handleTakeoff(scope.row.rinventory)">{{ scope.row.zinventory }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center" width="70">
          <template #default="scope">
            <span v-if="scope.row.num > 1" style="color: red">{{ scope.row.nout }}</span>
            <span v-else>{{ scope.row.nout }}</span>
          </template>
        </el-table-column>
        <el-table-column label="原库存" align="center" width="70" prop="noldSurplus" >
          <template #default="scope">
            {{ scope.row.noldSurplus + scope.row.nout }}
          </template>
        </el-table-column>
        <el-table-column v-if="pickingInfo.zstate === 2" label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="red" @click="handleShowSurplusDialog(scope.row)">校正库存</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex alignItemsCenter marginTop10" style="justify-content: space-between; flex: 1">
      <div>
        共计 <span class="blue">{{ tableData.length }}种</span> 货品
      </div>
      <div>
        <el-button v-if="pickingInfo.zstate === 3 || pickingInfo.zstate === 5" type="danger" @click="checkDestroy">核销</el-button>
      </div>
    </div>
    <el-dialog v-if="deviceDialogVisible" class="elDialog" :close-on-click-modal="false" title="查看门店智控" :visible.sync="deviceDialogVisible" width="400px" append-to-body>
      <deviceControl :store-info="storeInfo" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="库存校正" :visible.sync="surplusDialog" width="400px" append-to-body>
      <surplusSheet :picking-detail="pickingDetail" @handleSubmit="handleSurplusSheetSubmit" @handleClose="handleClose" />
    </el-dialog>
  </div>
</template>
<script>
import { formatTime } from "@/utils/utils";
import surplusSheet from "./surplusSheet.vue";
import deviceControl from "./deviceControl.vue";

export default {
  name: "PickingInfo",
  components: { surplusSheet, deviceControl },
  filters: {
    time(value) {
      if (value === null || value === "" || value === undefined) {
        return "";
      } else {
        return formatTime(value);
      }
    },
  },
  props: {
    sid: {
      type: [String, Object, Array],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      pickingId: "",
      pickingInfo: {},
      pickingDetail: {},
      tableData: [],
      // 智控弹窗
      deviceDialogVisible: false,
      deviceList: [],
      btnLoading: false,
      AccessControl: false,
      lighting: false,
      surplusDialog: false,
      selectedRows: [],
      channelOptions: [
        {
            "code": "CU009",
            "name": "美团"
        },
        {
            "code": "CU010",
            "name": "饿了么"
        },
        {
            "code": "CU011",
            "name": "京东到家"
        },
        {
            "code": "CU008",
            "name": "米度优选"
        },
        {
            "code": "CU019",
            "name": "吴勇"
        },
        {
            "code": "CU001",
            "name": "巨莱昂时代（福州）科技有限公司"
        },
        {
            "code": "CU005",
            "name": "巨莱昂（福州）供应链管理有限公司"
        },
        {
            "code": "CU006",
            "name": "巨莱昂（福州）品牌管理有限公司"
        },
        {
            "code": "CU003",
            "name": "福州起瑞科技有限公司"
        },
        {
            "code": "CU007",
            "name": "上海丰若奇产品模型设计制作有限公司"
        },
        {
            "code": "CU004",
            "name": "厦门米度优选科技有限公司"
        },
        {
            "code": "CU002",
            "name": "福州巨莱昂科技有限公司"
        },
        {
            "code": "CU025",
            "name": "陈舒怡"
        },
        {
            "code": "CU026",
            "name": "陈晞莹"
        },
        {
            "code": "CU027",
            "name": "中佰(海口)企业管理咨询有限公司"
        },
        {
            "code": "CU028",
            "name": "林敦钦"
        },
        {
            "code": "CU029",
            "name": "余诗伟"
        },
        {
            "code": "CU014",
            "name": "岳晓华"
        },
        {
            "code": "CU015",
            "name": "施传松"
        },
        {
            "code": "CU016",
            "name": "翁峰明"
        },
        {
            "code": "CU017",
            "name": "许祥海"
        },
        {
            "code": "CU018",
            "name": "曹建文"
        },
        {
            "code": "CU020",
            "name": "文锦"
        },
        {
            "code": "CU021",
            "name": "吴运琳"
        },
        {
            "code": "CU022",
            "name": "李海"
        },
        {
            "code": "CU023",
            "name": "福州思特源科技有限公司"
        },
        {
            "code": "CU024",
            "name": "陈云"
        },
        {
            "code": "CU030",
            "name": "代运营店群"
        },
        {
            "code": "CU031",
            "name": "朱尧春"
        },
        {
            "code": "CU033",
            "name": "福建熹锐科技有限公司"
        },
        {
            "code": "CU034",
            "name": "成都快购"
        },
        {
            "code": "CU035",
            "name": "杭州华橙网络科技有限公司"
        },
        {
            "code": "CU013",
            "name": "零星客户"
        },
        {
            "code": "CU032",
            "name": "合利宝"
        },
        {
            "code": "CU012",
            "name": "拼多多"
        },
        {
            "code": "CU036",
            "name": "陈桂龙"
        },
        {
            "code": "CU043",
            "name": "小程序商城"
        }
      ],
      pdSid: "",
      storeInfo: {},
    };
  },
  created() {
    this.pickingId = this.sid;
    this.selectById();
  },
  methods: {
    onSubmit() {
      if (this.pickingDetail.remake === undefined || this.pickingDetail.remake === '') {
        this.$message({
          message: "请填写备注（缺货/损坏/数量多了等）",
          type: "error",
        });
        return
      }
      if (this.pickingDetail.surplus > this.pickingDetail.n_total) {
        let url = `${this.baseUrls.orderRepInventoryOrderIn}/sheet/add`;
        this.topsAjax.post(url, { ...this.pickingDetail }).then(() => {
          this.$message({
            message: "校正成功",
            type: "success",
          });
          
          this.surplusDialog = false
        });
      } else {
        let url = `${this.baseUrls.orderRepInventoryOrderOut}/sheet/add`;
        this.topsAjax.post(url, { ...this.pickingDetail }).then(() => {
          this.$message({
            message: "校正成功",
            type: "success",
          });
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].pdSid === this.pickingDetail.pdSid) {
              this.tableData[i].n_total = this.pickingDetail.surplus
              let check = this.pickingDetail.n_total - this.pickingDetail.surplus
              this.tableData[i].n_surplus = this.tableData[i].n_surplus - check
              break;
            }
          }
          this.surplusDialog = false
        });
      }
    },
    handleSurplusSheetSubmit(surplus) {
      if (surplus > this.pickingDetail.nall) {
        for (let i = 0; i < this.pickTableData.length; i++) {
          if (this.pickTableData[i].sid === this.pickingDetail.sid) {
            this.pickTableData[i].nall = surplus;
            let check = surplus - this.pickingDetail.nall;
            this.pickTableData[i].navailable = this.pickTableData[i].n_surplus + check;
            break;
          }
        }
      } else {
        for (let i = 0; i < this.pickTableData.length; i++) {
          if (this.pickTableData[i].pdSid === this.pickingDetail.pdSid) {
            this.pickTableData[i].nall = surplus;
            let check = this.pickingDetail.nall - surplus;
            this.pickTableData[i].navailable = this.pickTableData[i].navailable - check;
            break;
          }
        }
      }
    },
    handleChooseGiveGoods(goodsList) {
      if (goodsList.length !== 0) {
        this.loading = true;
        this.topsAjax.post(`${this.baseUrls.ordPicking}/resetPicking`, { pickingId: this.pickingId, pickingDetailId: this.pdSid, goodsList }).then((res) => {
          let arr = [];
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.pdSid !== this.tableData[i].pdSid) {
              arr.push(this.tableData[i]);
            } else {
              for (let j = 0; j < res.length; j++) {
                arr.push(res[j]);
              }
            }
          }
          this.tableData = arr;
          this.loading = false;
        });
      }
    },
    handleTakeoff(inventoryId) {
      this.$confirm("对货品强制下架操作将不能再拣货，确认要强制下架？")
        .then((_) => {
          this.loading = true;
          let url = `${this.baseUrls.orderInventory}/offWarehouseById`;
          this.topsAjax.post(url, { sid: inventoryId }).then(() => {
            url = `${this.baseUrls.ordPicking}/change`;
            let params = { sid: this.sid };
            this.topsAjax.post(url, params).then((res) => {
              this.loading = false;
              this.$emit("handleUpdate", this.sid, this.pickingInfo.rorder);
            });
          });
        })
    },
    handleArriveEmptyDialog(pdSid) {
      this.pdSid = pdSid;
      this.$refs.orderGoodsAdd.setTableData([]);
    },
    handleShowSurplusDialog(row) {
      this.pickingDetail = { ...row }
      this.surplusDialog = true
    },
    checkSelectable(row) {
      if (row.b_valid === 0) {
        return false
      }
      return true
    },
    formatRow({row}) {
      console.log(row.b_valid)
      if (row.bvalid === 0) {
        return 'discard-row4'
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    activateInStore() {
      this.arrvLoading = true
      let url = `${this.baseUrls.iot}/activateInStore`;
      this.topsAjax.get(url, { storeId: this.pickingInfo.rstore }).then((res) => {
        this.arrvLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleDeviceRefresh() {
      this.deviceRefreshLoading = true
      let url = `${this.baseUrls.iot}/uploadData`
      this.topsAjax.get(url, { devUid: this.deviceInfo.code, type: this.deviceInfo.type }).then(() => {
        this.deviceRefreshLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.topsAjax.get(`${this.baseUrls.iot}/queryDevice?storeId=${this.storeInfo.sid}`).then((response) => {
          this.deviceInfo = response
        });
      });
    },
    handleDoorOpen() {
      this.doorOpenLoading = true
      let url = `${this.baseUrls.iot}/openOrCloseDoor`
      this.topsAjax.get(url, { storeId: this.pickingInfo.rstore, status: true }).then(() => {
        this.doorOpenLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleDoorClose() {
      this.doorCloseLoading = true
      let url = `${this.baseUrls.iot}/openOrCloseDoor`
      this.topsAjax.get(url, { storeId: this.pickingInfo.rstore, status: false }).then(() => {
        this.doorCloseLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleLightOpen() {
      this.lightOpenLoading = true
      let url = `${this.baseUrls.iot}/openOrCloseLight`
      this.topsAjax.get(url, { storeId: this.pickingInfo.rstore, status: true }).then(() => {
        this.lightOpenLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleLightClose() {
      this.lightCloseLoading = true
      let url = `${this.baseUrls.iot}/openOrCloseLight`
      this.topsAjax.get(url, { storeId: this.pickingInfo.rstore, status: false }).then(() => {
        this.lightCloseLoading = false
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    storeDevice(id) {
      this.topsAjax.get(`${this.baseUrls.orderStore}/selectById?sid=${id}`).then((response) => {
        this.storeName = response.store.ccode + response.store.cname
        this.storeAddr = response.store.caddr
      });
      this.topsAjax
        .get(`${this.baseUrls.iot}/queryImouList`, {
          storeId: id
        })
        .then((response) => {
          this.deviceList = response
        });
      this.topsAjax.get(`${this.baseUrls.iot}/queryDevice?storeId=${id}`).then((response) => {
        this.deviceInfo = response
      });
    },
    openVideo(item) {
      const url = `/components/videoWindows?deviceId=${item.code}&channelId=0&pwd=${item.password}&storeName=${this.storeName}&deviceName=${item.name}`;
      // 打开新标签页
      window.open(url, "_blank");
    },
    // --------------------------------------------
    selectById() {
      let url = `${this.baseUrls.ordPicking}/selectById`;
      let params = { sid: this.pickingId };
      this.topsAjax.get(url, params).then((res) => {
        this.pickingInfo = res.picking;
        this.tableData = res.pickingDetailList;
        this.topsAjax.get(`${this.baseUrls.orderStore}/get/` + this.pickingInfo.rstore).then((res) => {
          this.storeInfo = res;
        });
      });
    },
    //取消
    handleCancel() {
      this.$confirm("是否取消当前记录？")
        .then((_) => {
          this.topsAjax.post(`${this.baseUrls.ordPicking}/cancelById`, { sid: this.pickingId }).then((res) => {
            this.$message({
              message: "取消成功",
              type: "success",
            });
            this.handleClose();
          });
        })
        .catch((_) => {});
    },
    /**
     * 出货
     */
    shipment() {
      if (this.btnDisabled) {
        this.$message({
          message: "请勿重复操作",
          type: "info",
        });
        return
      }
      this.btnDisabled = true
      let url = `${this.baseUrls.ordPicking}/shipment`;
      let params = { sid: this.pickingId };
      this.topsAjax.post(url, params).then((res) => {
        this.$message({
          message: "出货成功",
          type: "success",
        });
        this.handleClose();
      });
    },
    /**
     * 改单
     */
    update() {
      let url = `${this.baseUrls.ordPicking}/change`;
      let params = { sid: this.pickingId };
      this.topsAjax.post(url, params).then((res) => {
        this.$emit("handleUpdate");
      }).catch((_) => {
        this.$message({
          message: "改单失败，请联系管理员",
          type: "error",
        });
      });
    },
    /**
     * 取消
     */
     handleClose() {
      this.$emit("handleClose");
    },
    checkDestroy() {
      if (this.selectedRows.length == 0) {
        this.$message({
              message: "请勾选需要核销的记录",
              type: "info",
            });
            return
      }
      let url = `${this.baseUrls.ordPicking}/checkDestroy`;
      let parameters = {
        pickingId: this.pickingId,
        goodsList: this.selectedRows
      };
      this.topsAjax.post(url, parameters).then((res) => {
        this.$message({
          message: "核销成功",
          type: "success",
        });
        this.handleClose();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
:deep .discard-row4 {
  text-decoration: line-through;
}
.PickingInfo {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__top {
    .el-divider--horizontal {
      margin: 7px 0;
    }

    .el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
      padding-bottom: 5px;
    }

    .el-input--medium .el-input__inner {
      height: 20px;
      line-height: 20px;
    }

    .el-input__inner {
      border: 0px;
    }

    //隐藏图标
    .el-input__icon {
      display: none;
    }
  }
}
</style>
